<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import instealledIndowInsertImg from './images/LP-Limited-Residential-Warranty-01.jpg';
</script>

<Section backgroundImage={instealledIndowInsertImg} backgroundColor="blue">
	<h1>Limited Residential Lifetime Warranty</h1>
</Section>
<Section
	class="
   max-md:[&_h3]:w-full max-md:[&_h3]:text-left
   [&_p]:w-full [&_p]:text-left
 "
>
	<p>
		R Value, Inc. doing business as Indow (“Indow”) provides this Limited
		Residential Warranty to purchasers who use the product in a non-commercial
		property, non income-generating purpose. Click <a
			href="/warranties/commercial-warranty">here</a
		>
		to view our Limited Commercial Warranty. Click
		<a href="/static/pdfs/IW-Care-Guide-Limited-Warranty_05-01-14.pdf">here</a> to
		view Indow warranty information for purchases prior to 1/1/15. Indow warrants
		its window inserts against defects of materials or workmanship as long as the
		purchaser continuously occupies the property for which the window insert was purchased.
		This warranty is not transferable.
	</p>
	<h2 class="text-left text-lg uppercase">GLAZING & FRAME TUBING</h2>
	<p>
		Indow uses only the highest quality materials in the manufacture of our
		products. Indow warrants its clear acrylic glazing against a change in light
		transmission in excess of 3%. This warranty does not cover certain specialty
		grades that are not clear to start with (including Sleep Panels, Privacy and
		Shade Grades), our film product, nor clear acrylic glazing exposed to
		artificial light sources emitting intense amounts of UVB or higher energy
		radiation. The Indow compression material is made of silicone which resists
		the effects of heat, cold and ultraviolet exposure.
	</p>

	<h2 class="text-left text-lg uppercase">EXCLUSIONS</h2>
	<p>
		This warranty does not apply to any Indow window insert which has been
		subject to accident, acts of God, fire, flood, abuse or misuse, abuse by
		harmful fumes, vapors, solvents, chemicals or chemical pollutants in the
		atmosphere, mold, building settlement or structural failures of walls or
		foundations. We do not warrant our glazing against scratching or breakage
		which can occur if improperly handled, as listed in our Receiving & Handling
		Guide. This warranty does not apply to any Indow window insert that has been
		subject to operating temperatures exceeding 160 degrees Fahrenheit. We do
		not warrant our acrylic glazing against clouding, yellowing or loss of light
		transmission caused by dirt, scratching, breakage, or improper cleaning with
		ammonia or bleach-based cleaners, as listed in our Care Guide (see link
		below).
	</p>

	<h2 class="text-left text-lg uppercase">CONDENSATION</h2>
	<p>
		Condensation is not a product defect, but the result of excess humidity.
		Condensation, frost, or mold, mildew, or fungus on window surfaces is not
		covered by the Limited Warranty. Indow bears no responsibility or liability
		for any situation where molds or other associated conditions arise as a
		result of improper use, cleaning, sealing, humidification or ventilation.
	</p>

	<h2 class="text-left text-lg uppercase">VENTING</h2>
	<p>
		Indow does not warrant its inserts against venting excess air pressure. It
		is part of an Indow insert’s normal function to occasionally relieve excess
		air pressure by ‘popping’ a corner or side in response to heavy external
		winds combined with extreme temperatures or a blower door test. Simply press
		the insert back into place to restore normal function.
	</p>

	<h2 class="text-left text-lg uppercase">WINDOW OPENNING CONTROL DEVICES</h2>
	<p>
		Indow window inserts are not Window Opening Control Devices (WOCDs) and they
		are not intended as a substitute for careful supervision of children near
		windows. WOCDs, if installed on primary windows, must be tested at least
		monthly. Follow all safety information and instructions provided with WOCDs.
	</p>
	<p>
		Indow will not pay for any incidental or consequential damages, and its
		liability under this warranty, or under any implied warranty, is limited to
		repairing or replacing (in its sole discretion) any part or parts of the
		window insert that are found to be defective under the terms of this
		warranty. We will endeavor to supply original replacement parts; however,
		replacement parts may differ from the original parts. Warranty repair or
		replacement of the Indow window insert is free of charge to you. In the case
		of improper cleaning, storage or maintenance, Indow will not be held
		responsible for any costs incurred in repairing or replacing any product
		under this warranty including, but not limited to, transportation costs,
		costs of removal, disposal, installation or reinstallation.
	</p>
	<p>
		Approved care, cleaning, and installation instructions are available
		<a href="/about-indow/care">here</a>.
	</p>

	<h2 class="text-left text-lg uppercase">TO MAKE A CLAIM</h2>
	<p>
		If you discover a defect of materials or workmanship, please contact Indow.
		Upon providing proof of purchase (Indow in its sole discretion) will repair
		or replace your defective Indow window insert(s) or its components. This
		limited warranty is effective for products purchased on or after October 31,
		2021.
	</p>
</Section>
